<template>
    <div>
      <h1 class="text-success">Formulario nombre enfermedad ETMI</h1>
      <div class="alert alert-info" role="alert">
      <strong>Nota:</strong> Estas opciones corresponden al tamizaje por el tipo de enfermedad en el listado dentro del formulario(mujer) ETMI
    </div>
      <div class="mt-4">
        <button @click="showCreateForm" class="btn btn-primary">Agregar nombre enfermedad ETMI</button>
      </div>
  
      <!-- Lista de ETMIVacunas en una tabla -->
      <div class="table-responsive mt-3">
        <table class="table table-bordered">
          <thead class="thead-light">
            <tr>
              <th>Nombre enfermedad</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="etmivacuna in etmivacunas" :key="etmivacuna._id">
              <td>{{ etmivacuna.vacuna }}</td>
              <td>
                <div class="btn-group" role="group">
                  <button @click="editETMIVacuna(etmivacuna)" class="btn btn-warning btn-sm">Editar</button>
                  <button @click="deleteETMIVacuna(etmivacuna._id)" class="btn btn-danger btn-sm">Eliminar</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  
      <!-- Formulario de creación/editar -->
      <div v-if="showForm" class="mt-4">
        <h2 class="h4">{{ isEditing ? 'Editar ETMIVacuna' : 'Agregar ETMIVacuna' }}</h2>
        <form @submit.prevent="isEditing ? updateETMIVacuna() : createETMIVacuna()" class="form-inline">
          <div class="form-group mr-2">
            <label for="vacuna" class="mr-2">Vacuna</label>
            <input v-model="formData.vacuna" type="text" id="vacuna" required class="form-control form-control-lg" />
          </div>
          <div class="btn-group">
            <button type="submit" class="btn btn-primary">{{ isEditing ? 'Guardar Cambios' : 'Agregar' }}</button>
            <button @click="cancelEdit" class="btn btn-secondary">Cancelar</button>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import swal from 'sweetalert';
  import { BASE_URL } from '../store/config';
  
  export default {
    computed: {
      currentUser() {
        return this.$store.state.auth.user;
      },
    },
    data() {
      return {
        etmivacunas: [],
        showForm: false,
        formData: {
          vacuna: '',
        },
        isEditing: false,
        editingETMIVacunaId: null,
      };
    },
    methods: {
      async fetchETMIVacunas() {
        try {
          const response = await axios.get(`${BASE_URL}/api/etmivacuna`, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          this.etmivacunas = response.data;
        } catch (error) {
          console.error('Error al obtener ETMIVacunas:', error);
        }
      },
      showCreateForm() {
        this.showForm = true;
        this.isEditing = false;
        this.formData = {
          vacuna: '',
        };
      },
      async createETMIVacuna() {
        try {
          await axios.post(`${BASE_URL}/api/etmivacuna`, this.formData, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          swal({
            title: '¡Información Guardada!',
            text: 'La información de ETMIVacuna ha sido guardada correctamente.',
            icon: 'success',
            button: 'OK',
          });
          this.clearFields();
          this.fetchETMIVacunas();
          this.showForm = false;
        } catch (error) {
          swal({
            title: 'Error',
            text: `Hubo un error al guardar la información de ETMIVacuna. \n ${error.response.data.message}.`,
            icon: 'error',
            button: 'OK',
          });
        }
      },
      clearFields() {
        this.formData = {
          vacuna: '',
        };
      },
      deleteETMIVacuna(id) {
        swal({
          title: '¿Estás seguro?',
          text: 'Una vez eliminado, no podrás recuperar este registro.',
          icon: 'warning',
          buttons: ['Cancelar', 'Eliminar'],
          dangerMode: true,
        })
        .then((confirmation) => {
          if (confirmation) {
            this.performETMIVacunaDeletion(id);
          }
        });
      },
      async performETMIVacunaDeletion(id) {
        try {
          await axios.delete(`${BASE_URL}/api/etmivacuna/${id}`, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          swal({
            title: '¡Información Eliminada!',
            text: 'La información de ETMIVacuna ha sido eliminada correctamente.',
            icon: 'success',
            button: 'OK',
          });
          this.fetchETMIVacunas();
        } catch (error) {
          swal({
            title: 'Error',
            text: 'Hubo un error al eliminar la información de ETMIVacuna.',
            icon: 'error',
            button: 'OK',
          });
        }
      },
      editETMIVacuna(etmivacuna) {
        this.isEditing = true;
        this.editingETMIVacunaId = etmivacuna._id;
        this.formData.vacuna = etmivacuna.vacuna;
        this.showForm = true;
      },
      async updateETMIVacuna() {
        try {
          await axios.put(`${BASE_URL}/api/etmivacuna/${this.editingETMIVacunaId}`, this.formData, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          swal({
            title: '¡Información Actualizada!',
            text: 'La información de ETMIVacuna ha sido actualizada correctamente.',
            icon: 'success',
            button: 'OK',
          });
          this.clearFields();
          this.fetchETMIVacunas();
          this.showForm = false;
        } catch (error) {
          swal({
            title: 'Error',
            text: `Hubo un error al editar la información de ETMIVacuna. \n ${error.response.data.message}.`,
            icon: 'error',
            button: 'OK',
          });
        }
      },
      cancelEdit() {
        this.showForm = false;
        this.isEditing = false;
        this.clearFields();
      },
    },
    mounted() {
      this.fetchETMIVacunas();
    },
  };
  </script>
  
  <style scoped>
  /* Estilos adicionales si es necesario */
  </style>
  